import gql from "graphql-tag";

export const GET_DEFAULT_ROLES = gql`
  query GetDefaultRoles {
    defaultRoles {
      status
      error
      data {
        id
        name
        hourlyRate
      }
    }
  }
`;
